import _ from 'lodash';
import customFilterColumnsExtend from '../../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../../admin_entities/walk/prize_detail.js';
import { shareColumnsExtend } from '../share';
const filterColumns = {
  title_cont: {
    model_name: 'Walk::Prize',
    column_type: 'string',
    column_name: 'title',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: false, disabledUpdate: false },
    'introduction': { required: false, disabledUpdate: false },
    'covers': { required: false, disabledUpdate: false },
    'images': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Walk::Prize', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Walk::Prize', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
